
import { Dealer } from '@/types/dealer';
import { fetchRecommendedDealersData } from './fetchData';
import { 
  setPrefetchedDealers, 
  getPrefetchedDealersFromCache 
} from './cache';

let prefetchInProgress = false;

/**
 * Prefetch recommended dealers data for given metal type
 * @param metalType The metal type to prefetch data for
 * @param forceRefresh Whether to force a refresh of the data
 * @returns A promise that resolves when prefetching is complete
 */
export const prefetchRecommendedDealers = async (
  metalType: string = 'ORO',
  forceRefresh: boolean = false
): Promise<void> => {
  // Prevent multiple concurrent prefetches
  if (prefetchInProgress) {
    console.log('Prefetch already in progress, skipping');
    return;
  }
  
  try {
    console.log(`Starting prefetch for ${metalType} dealers (force: ${forceRefresh})`);
    prefetchInProgress = true;
    
    // Skip prefetch if we already have data and not forcing refresh
    if (!forceRefresh && hasPrefetchedDealers()) {
      console.log('Dealers already prefetched, skipping');
      return;
    }
    
    // Fetch fresh data
    const dealers = await fetchRecommendedDealersData(metalType, null, false, forceRefresh);
    
    if (dealers && dealers.length > 0) {
      console.log(`Prefetched ${dealers.length} ${metalType} dealers`);
      setPrefetchedDealers(metalType, dealers);
      
      // Log each dealer's rating
      dealers.forEach(dealer => {
        console.log(`Prefetched dealer ${dealer.name} with rating:`, dealer.rating);
      });
    } else {
      console.log('No dealers to prefetch');
    }
  } catch (error) {
    console.error('Error during dealers prefetch:', error);
  } finally {
    prefetchInProgress = false;
  }
};

/**
 * Check if dealers have been prefetched
 * @returns True if dealers have been prefetched, false otherwise
 */
export const hasPrefetchedDealers = (): boolean => {
  const prefetchedDealers = getPrefetchedDealersFromCache();
  const hasDealers = Boolean(prefetchedDealers && prefetchedDealers.length > 0);
  
  console.log(`Prefetched dealers check: ${hasDealers ? 'available' : 'not available'}`);
  
  if (hasDealers) {
    console.log(`${prefetchedDealers?.length} prefetched dealers available`);
  }
  
  return hasDealers;
};
